import * as Redux from 'redux';
import { router } from 'redux-ui-router';

import activation from './activation';
import passwordReset from './passwordReset';
import changePassword from './changePassword';
import count from './count';
import authentication from './auth';
import users from './users';
import companies from './companies';
import businessInformations from './businessInformations';
import enums from './enum';
import technicalInformations from './techDoc';
import orders from './orders';
import navigation from './navigation';
import priceList from './priceList';
import questionnaires from './questionnaires';
import countries from './countries';
import businessInformationTemplates from './businessInformationTemplates';
import contracts from './contracts';
import search from './search';
import questionnaireTemplates from './questionnaireTemplates';
import budgets from './budgets';
import summaries from './summaries';

const appReducer = Redux.combineReducers({
  count,
  authentication,
  passwordReset,
  changePassword,
  router,
  users,
  activation,
  companies,
  businessInformations,
  enums,
  technicalInformations,
  orders,
  navigation,
  priceList,
  questionnaires,
  countries,
  businessInformationTemplates,
  contracts,
  search,
  questionnaireTemplates,
  budgets,
  summaries,
});

const rootReducer = (state, action) => {
  let safeState = state;
  if (action.type === 'REQUEST_LOGOUT') {
    safeState = undefined;
  }

  return appReducer(safeState, action);
};

export default rootReducer;
